export default __webpack_public_path__ + "static/media/mouse.a97267f5.png";